import React from "react";
import Slider from "react-slick";
import { SlArrowRight } from "react-icons/sl";
import { SlArrowLeft } from "react-icons/sl";


function FirstScreenSpeacers({ slider_data }) {
    const sliderRef = React.useRef(null); // Рефер на слайдер для управління стрілками

    const settings = {
        dots: false,
        arrows: false, // Вимикаємо стандартні стрілки
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 1
    };

    return (
        slider_data ? (
            <div className="relative sm:order-1 order-2">
                {/* Навігаційні стрілки */}
                <div className="absolute top-1/2 transform -translate-y-1/2 sm:left-10 left-0 z-20 opacity-40 hover:opacity-100">
                    <button
                        className="p-3"
                        onClick={() => sliderRef.current.slickPrev()}
                    >
                        <SlArrowLeft className="text-3xl" />
                    </button>
                </div>
                <div className="absolute top-1/2 transform -translate-y-1/2 sm:right-10 right-0 z-20 transition-all duration-200 opacity-40 hover:opacity-100">
                    <button
                        className="p-3"
                        onClick={() => sliderRef.current.slickNext()}
                    >
                        <SlArrowRight className="text-3xl" />
                    </button>
                </div>

                <div className="gallery">
                    <div className="slider-container">
                        {/* Передаємо референс у Slider */}
                        <Slider ref={sliderRef} {...settings} className="[&_.slick-track]:flex [&_.slick-slide]:h-auto [&_.slick-slide>div]:h-full">
                            {
                                slider_data.map((item, value) => (
                                    <>
                                        {item.acf.big_image ? (
                                            <div className="relative h-full flex flex-col justify-end " key={value}>
                                                <div>
                                                    <img
                                                        src={item.acf.big_image}
                                                        alt={item.acf.speacer_name}
                                                        className="relative left-0 right-0 m-auto z-10 !w-auto h-[100%] max-h-[400px] sm:max-h-[510px] lg:max-h-[520px] 2xl:max-h-[580px]"
                                                    />
                                                </div>
                                                <div className="z-20 right-0 flex sm:w-[90%] w-[100%] justify-center items-center flex-wrap bg-white p-2">
                                                    {item.acf.logo ? (
                                                        <div className="p-2 w-[100px] mr-[15px]">
                                                            <img
                                                                src={item.acf.logo}
                                                                alt="logo"
                                                                className="max-h-[50px] mx-auto"
                                                            />
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}

                                                    <div className="w-[calc(100%-115px)]">
                                                        <h3 className="font-semibold uppercase mb-1">
                                                            {item.post_title}
                                                        </h3>
                                                        <p className="text-[13px] leading-tight">
                                                            {item.acf.position_short
                                                                ? item.acf.position_short
                                                                : item.acf.position}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </>
                                ))
                            }
                        </Slider>
                    </div>
                </div>
            </div>
        ) : (
            ""
        )
    );
}

export default FirstScreenSpeacers;